// The frame around every page: logo, navigation, page titles, header and its menus.
export default {
  tagline: "private agent cloud",
  groups: { overview: "Overview", product: "Product", security: "Security", admin: "Admin", platform: "Platform" },
  /** Each route's title and subtitle (layout/nav.ts); the header and the browser tab show them. */
  pages: {
    home: { title: "Home", subtitle: "What needs you, what is running, and how the host is doing" },
    workflows: { title: "Workflows", subtitle: "Graphs of prompts, branches and approvals that task groups run" },
    workflow: { title: "Workflow", subtitle: "Graph, requirements, versions, ratings and settings" },
    taskTypes: { title: "Task types", subtitle: "The categories workflows and task groups belong to" },
    taskGroups: { title: "Task groups", subtitle: "Every user's task groups, their tasks and where each one is in its workflow" },
    newTaskGroup: { title: "New task group", subtitle: "A kind of work, a workflow, where tasks come from and the secrets it uses" },
    taskGroup: { title: "Task group", subtitle: "Its source, requirements, tasks and costs" },
    task: { title: "Task", subtitle: "Where it is in its workflow, its steps and timeline" },
    costs: { title: "Costs", subtitle: "What the agents' steps cost, by user, task group and task, and whose key paid" },
    skills: { title: "Skills", subtitle: "Reusable instructions workflow steps use, written into the workspace before every step" },
    skill: { title: "Skill", subtitle: "Its files and details" },
    secrets: { title: "Secrets", subtitle: "Encrypted in this browser; changes are signed by your device" },
    devices: { title: "Devices", subtitle: "Phones and linked browsers that hold your keys" },
    network: { title: "Network", subtitle: "Which domains your agents' containers may reach" },
    networkList: { title: "Network list", subtitle: "Its domains and the task groups that use it" },
    taskGroupNetwork: { title: "Network", subtitle: "What this group's agents reached and what was blocked" },
    taskGroupChat: { title: "Chat", subtitle: "Talk to the agent about this task group" },
    taskChat: { title: "Chat", subtitle: "Talk to the agent about this task" },
    users: { title: "Users", subtitle: "Who can sign in, their roles, invitations" },
    roles: { title: "Roles", subtitle: "What each role may do" },
    resourceLimits: { title: "Resource limits", subtitle: "How much CPU and memory environments get, by default, per role and per person" },
    platformKeys: { title: "Platform keys", subtitle: "The platform's own credentials, such as the default model key task groups fall back to" },
    settings: { title: "Settings", subtitle: "Platform settings, such as how workflow ratings are weighed" },
    account: { title: "Account", subtitle: "Your sign-in and password" },
    orgs: { title: "Organisations", subtitle: "Tenants: one Incus project and quota each" },
    environments: { title: "Environments", subtitle: "Isolated Incus instances with their own network, VPN and Docker" },
    environment: { title: "Environment", subtitle: "Limits, workspaces, network and egress" },
    legacyWorkflows: { title: "Legacy runs", subtitle: "Single-prompt workflows of the organisation model, and starting their runs" },
    legacyWorkflow: { title: "Workflow", subtitle: "Prompt, trigger, tool policy and recent runs" },
    runs: { title: "Runs", subtitle: "What the agents did, and what they are doing now" },
    run: { title: "Run", subtitle: "Status, questions, and the answers you give" },
    runPreview: { title: "Run", subtitle: "Design preview" },
    workspaces: { title: "Workspaces", subtitle: "Repositories and the interactive worker you SSH into" },
    terminal: { title: "Terminal", subtitle: "Shell into the workspace's interactive worker" },
    environmentTerminal: { title: "Root shell", subtitle: "A root shell in your own environment" },
    environmentVpn: { title: "VPN", subtitle: "Your environment's connection to your company network" },
    conversations: { title: "Conversations", subtitle: "End-to-end encrypted; the host sees metadata only" },
    conversation: { title: "Conversation", subtitle: "Decrypted in this browser with its device key" },
    notFound: { title: "Not found", subtitle: "No such page" },
  },
  sections: "Sections",
  tabs: "Tabs",
  answer: "Answer",
  rail: { collapseNav: "Collapse navigation", expandNav: "Expand navigation" },
  header: {
    openMenu: "Open menu",
    searchUnavailable: "Search is not available yet",
    searchPlaceholder: "Search runs, workflows, secrets…",
    toLight: "Switch to light mode",
    toDark: "Switch to dark mode",
    waiting: (n: number) => `Waiting for you: ${n}`,
    nothingWaiting: "Nothing waiting for you",
    profile: "Profile menu",
    accountAndPassword: "Account and password",
    myDevices: "My devices",
    signOut: "Sign out",
  },
  notifications: {
    title: "Waiting for you",
    subtitle: "Agents pause until one of your devices answers",
    empty: "Nothing is waiting for you.",
    aRun: "A run",
    asked: (name: string) => `${name} asked a question`,
    encrypted: (ago: string) => `${ago} · end-to-end encrypted`,
    wantsToLink: (name: string) => `${name} wants to link`,
    checkFingerprint: "Check its fingerprint before approving",
  },
  routeError: {
    updating: "Updating to the new version…",
    newVersion: "A new version is available",
    failed: "This page hit an error",
    reload: "Reload",
    updated: "The platform was updated while this tab was open. Reload to continue.",
  },
};
